import {createAction} from '@reduxjs/toolkit';
import {
  type FeatureCollectionId,
  type FeatureRef,
} from '@src/types/featureCollections.ts';

const actionPrefix = 'FEATURE_COLLECTIONS';

export const selectCollectionId = createAction<FeatureCollectionId | null>(
  `${actionPrefix}/SELECT_COLLECTION_ID`,
);

export const selectCollectionFeatureRef = createAction<FeatureRef | null>(
  `${actionPrefix}/SELECT_COLLECTION_FEATURE_REF`,
);
